module.exports = __webpack_public_path__ + "pdfs/Terms of Use.pdf";